import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import { Link } from 'react-router-dom';

function Accessibility() {
  const { language } = useContext(LanguageContext);

  const text = {
    en: {
      title: "Accessibility Information",
      intro: "The ISET portal is designed to reduce barriers and support applicants in ways that are clear, flexible, and accessible. This page explains accessibility features and how to request support.",
      webAccessibility: "Web Accessibility",
      webHint: "The Web Content Accessibility Guidelines (WCAG) can be summarized in five key points:",
      feature1: "Perceivable: information is presented in ways people can perceive, including text alternatives and clear visual structure.",
      feature2: "Operable: users can navigate and use all core functions, including by keyboard.",
      feature3: "Understandable: content and interactions are clear, predictable, and support error recovery.",
      feature4: "Robust: content works with assistive technologies and modern browsers.",
      feature5: "Conformance: WCAG uses Levels A, AA, and AAA, with AA commonly used as the public service target.",
      requestAssistance: "Requesting Assistance",
      requestHint1: "If you need accessibility support at any stage of your ISET application, contact the support team. You only need to share the details required to help us arrange support.",
      requestHint2: "If part of the portal is difficult to use, tell us what is not working. We will work with you on another format, a workaround, or next steps.",
      contactUs: "Get Help and Support",
      backToHome: "Back to Home"
    },
    fr: {
      title: "Informations sur l'accessibilité",
      intro: "Le portail ISET est conçu pour réduire les obstacles et offrir un parcours clair, souple et accessible. Cette page présente les fonctionnalités d'accessibilité et la façon d'obtenir du soutien.",
      webAccessibility: "Accessibilité Web",
      webHint: "Les directives pour l'accessibilité du contenu Web (WCAG) peuvent se résumer en cinq points clés :",
      feature1: "Perceptible : l'information est présentée de façon à pouvoir être perçue, notamment avec des textes de remplacement et une structure visuelle claire.",
      feature2: "Utilisable : les personnes peuvent naviguer et utiliser toutes les fonctions essentielles, y compris au clavier.",
      feature3: "Compréhensible : le contenu et les interactions sont clairs, prévisibles et favorisent la correction des erreurs.",
      feature4: "Robuste : le contenu fonctionne avec les technologies d'assistance et les navigateurs modernes.",
      feature5: "Conformité : les WCAG utilisent les niveaux A, AA et AAA, le niveau AA étant couramment visé pour les services publics.",
      requestAssistance: "Demande d'assistance",
      requestHint1: "Si vous avez besoin d'un soutien en accessibilité à n'importe quelle étape de votre demande ISET, communiquez avec l'équipe de soutien. Vous n'avez qu'à fournir les renseignements nécessaires pour nous aider à mettre le soutien en place.",
      requestHint2: "Si une partie du portail est difficile à utiliser, indiquez-nous ce qui ne fonctionne pas. Nous travaillerons avec vous pour proposer un autre format, une solution de rechange ou la suite à donner.",
      contactUs: "Obtenir de l'aide et du soutien",
      backToHome: "Retour à l'accueil"
    }
  };

  return (
    <div>
      <main className="govuk-main-wrapper govuk-width-container" role="main">
        <h1 className="govuk-heading-l">{text[language].title}</h1>
        <p className="govuk-body">
          {text[language].intro}
        </p>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].webAccessibility}</h2>
          <p className="govuk-body">
            {text[language].webHint}
          </p>
          <ul className="govuk-list govuk-list--bullet">
            <li>{text[language].feature1}</li>
            <li>{text[language].feature2}</li>
            <li>{text[language].feature3}</li>
            <li>{text[language].feature4}</li>
            <li>{text[language].feature5}</li>
          </ul>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].requestAssistance}</h2>
          <p className="govuk-body">
            {text[language].requestHint1}
          </p>
          <p className="govuk-body">
            {text[language].requestHint2}
          </p>
        </section>

        <div className="govuk-button-group">
          <Link to="/help" className="govuk-button govuk-button--secondary">{text[language].contactUs}</Link>
          <Link to="/" className="govuk-button">{text[language].backToHome}</Link>
        </div>
      </main>
    </div>
  );
}

export default Accessibility;
